var _style, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFluxo01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCD770;}\n\t.st1{fill:#5CD6B3;}\n\t.st2{fill:#E6E9ED;}\n\t.st3{fill:#F0D0B4;}\n\t.st4{fill:#FF826E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1329",
    className: "st0",
    d: "M9.3,14.7l-3.9,2.8l-3.9-2.8l3.9-2.8L9.3,14.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1330",
    className: "st0",
    d: "M24.9,23.6l-4.4,2.8L16,23.6l4.4-2.8L24.9,23.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1327",
    className: "st1",
    d: "M25.4,31.3v2.2c0,0.6-0.5,1.1-1.1,1.1h-7.8c-0.6,0-1.1-0.5-1.1-1.1v-2.2 c0-0.6,0.5-1.1,1.1-1.1h7.8C24.9,30.2,25.4,30.7,25.4,31.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1328",
    className: "st2",
    d: "M23.8,13v3.3h-6.7V13H23.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1331",
    className: "st3",
    d: "M24.9,1.3V8H16V1.3H24.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_48",
    className: "st4",
    cx: 5.4,
    cy: 32.4,
    r: 1.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_49",
    className: "st4",
    cx: 33.8,
    cy: 4.7,
    r: 1.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_50",
    className: "st4",
    cx: 33.8,
    cy: 23.6,
    r: 1.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1332",
    d: "M24.3,29.7H21v-3l4.9-3.1L21,20.5v-3.6h3.3v-4.4H21V8.6h4.4V0.8h-10v7.8h4.4v3.9h-3.3v1.7h-5v1.1h5v1.7 h3.3v3.6l-4.9,3.1l4.9,3.1v3h-3.3c-0.9,0-1.7,0.7-1.7,1.7v2.2c0,0.9,0.7,1.7,1.7,1.7h7.8c0.9,0,1.7-0.7,1.7-1.7c0,0,0,0,0,0v-2.2 C26,30.4,25.2,29.7,24.3,29.7z M16.5,7.4V1.9h7.8v5.6H16.5z M17.6,15.8v-2.2h5.6v2.2H17.6z M17,23.6l3.4-2.1l3.4,2.1l-3.4,2.1 L17,23.6z M24.9,33.6c0,0.3-0.2,0.6-0.6,0.6c0,0,0,0,0,0h-7.8c-0.3,0-0.6-0.2-0.6-0.6v-2.2c0-0.3,0.2-0.6,0.6-0.6c0,0,0,0,0,0h7.8 c0.3,0,0.6,0.2,0.6,0.6l0,0L24.9,33.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1333",
    d: "M10.6,30.6l1.3,1.3H7c-0.2-0.5-0.5-0.8-1-1V19.1H4.9v11.8c-0.9,0.3-1.3,1.3-1,2.1s1.3,1.3,2.1,1 c0.5-0.2,0.8-0.5,1-1h4.9l-1.3,1.3l0.8,0.8l2.6-2.6l-2.6-2.6L10.6,30.6z M5.4,33c-0.3,0-0.6-0.2-0.6-0.6s0.2-0.6,0.6-0.6 S6,32.1,6,32.4l0,0C6,32.8,5.7,33,5.4,33L5.4,33z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1334",
    d: "M34.3,22V6.2c0.9-0.3,1.3-1.3,1-2.1c-0.3-0.9-1.3-1.3-2.1-1c-0.5,0.2-0.8,0.5-1,1h-5.7v1.1h5.7 c0.2,0.5,0.5,0.8,1,1V22c-0.5,0.2-0.8,0.5-1,1h-3.8l1.3-1.3l-0.8-0.8l-2.6,2.6l2.6,2.6l0.8-0.8l-1.3-1.3h3.8c0.3,0.9,1.3,1.3,2.1,1 c0.9-0.3,1.3-1.3,1-2.1C35.2,22.5,34.8,22.2,34.3,22L34.3,22z M33.8,4.1c0.3,0,0.6,0.2,0.6,0.6c0,0.3-0.2,0.6-0.6,0.6 c-0.3,0-0.6-0.2-0.6-0.6c0,0,0,0,0,0C33.2,4.4,33.5,4.1,33.8,4.1L33.8,4.1L33.8,4.1z M33.8,24.1c-0.3,0-0.6-0.2-0.6-0.6 c0-0.3,0.2-0.6,0.6-0.6c0.3,0,0.6,0.2,0.6,0.6c0,0,0,0,0,0C34.3,23.9,34.1,24.1,33.8,24.1L33.8,24.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1335",
    d: "M10.3,14.7l-4.8-3.5l-4.8,3.5l4.8,3.5L10.3,14.7z M5.4,12.6l2.9,2.1l-2.9,2.1l-2.9-2.1L5.4,12.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1336",
    d: "M17.6,3h5.6v1.1h-5.6V3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1337",
    d: "M17.6,5.2H21v1.1h-3.3V5.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1338",
    d: "M22.1,5.2h1.1v1.1h-1.1V5.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1339",
    d: "M27.1,31.9h1.1V33h-1.1V31.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1340",
    d: "M29.3,31.9h1.1V33h-1.1V31.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1341",
    d: "M31.5,31.9h1.1V33h-1.1L31.5,31.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1342",
    d: "M13.2,5.2h1.1v1.1h-1.1V5.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1343",
    d: "M8.8,5.2h1.1v1.1H8.8V5.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1344",
    d: "M11,5.2h1.1v1.1H11V5.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFluxo01);
export default __webpack_public_path__ + "static/media/ico-fluxo-01.ebd61748d391d4e42bc5ae43c88b9a53.svg";
export { ForwardRef as ReactComponent };